var map = {
	"./404.svg": 7585,
	"./AE.png": 8285,
	"./AM.png": 8565,
	"./About busines.avif": 8478,
	"./About busines.png": 9075,
	"./About business.png": 8864,
	"./Advantages-img.avif": 8154,
	"./Advantages-img.png": 5095,
	"./BH.png": 6317,
	"./BY.png": 2836,
	"./Box_alt.svg": 3682,
	"./Button-sent.svg": 8602,
	"./Button.svg": 2983,
	"./CDEK.svg": 8970,
	"./DHL.svg": 289,
	"./DZ.png": 1309,
	"./Desk_alt.svg": 6696,
	"./E-commerce.png": 8528,
	"./EG.png": 6611,
	"./Ellipse 378.svg": 4809,
	"./Ellipse_icon.svg": 7089,
	"./Error.svg": 9047,
	"./Fedex.svg": 2859,
	"./Header Image 1.avif": 6289,
	"./Header Image 1.png": 7686,
	"./Header business.avif": 1783,
	"./Header business.png": 8536,
	"./Icon-calculator.svg": 9089,
	"./Image Services.avif": 4525,
	"./Image Services.png": 4954,
	"./JO.png": 1354,
	"./KG.png": 5981,
	"./KW.png": 5533,
	"./KZ.png": 2040,
	"./MA.png": 557,
	"./MT.png": 4352,
	"./Map.png": 5273,
	"./OM.png": 1355,
	"./Oval-1.svg": 9853,
	"./Oval-solutions.svg": 8624,
	"./Oval.svg": 7147,
	"./PP_Logo.svg": 1511,
	"./QA.png": 3321,
	"./RU.png": 6040,
	"./Rectangle 5403.avif": 8269,
	"./Rectangle 5403.png": 6378,
	"./SA.png": 1955,
	"./Star.svg": 1895,
	"./TJ.png": 4669,
	"./TN.png": 2873,
	"./UPS.svg": 631,
	"./US Postal.svg": 8324,
	"./UZ.png": 8278,
	"./Vector 110 sm.svg": 9124,
	"./Vector 110.svg": 7912,
	"./airship.svg": 8739,
	"./b2b-back.avif": 9724,
	"./b2b-back.png": 2589,
	"./b2b-horizontal.avif": 895,
	"./b2b-horizontal.png": 7456,
	"./bayer-img.png": 4768,
	"./box02.png": 8394,
	"./check-icon.svg": 7645,
	"./contact_icon.svg": 2539,
	"./crane.svg": 6062,
	"./flag-mexico-orig.png": 2031,
	"./flag-mexico.png": 1329,
	"./flash.svg": 2351,
	"./individual-price-bacground-small.avif": 1167,
	"./individual-price-bacground-small.png": 3360,
	"./individual-price-bacground.avif": 5525,
	"./individual-price-bacground.png": 9442,
	"./lightning.svg": 4603,
	"./manager-back-horizontal.avif": 9470,
	"./manager-back-horizontal.png": 3619,
	"./manager-back.avif": 1563,
	"./manager-back.png": 7924,
	"./messages1.svg": 552,
	"./messages2.svg": 1915,
	"./note04.png": 1299,
	"./parcel point footer.svg": 9067,
	"./parcel.svg": 9236,
	"./parcel06.png": 8414,
	"./phone01.png": 158,
	"./plane.svg": 3843,
	"./plane05.png": 3800,
	"./reliability-icon.svg": 3577,
	"./safety-icon.svg": 3797,
	"./star-big.svg": 2378,
	"./tractor03.png": 2825,
	"./wms-card-background-small.avif": 6313,
	"./wms-card-background-small.png": 3630,
	"./wms-card-background.avif": 851,
	"./wms-card-background.png": 348
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;